import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '../utils/cn';

type TextInputProps = InputHTMLAttributes<HTMLInputElement>;

const BASE =
  'block w-full rounded-md border border-hilevel-border bg-white px-3 py-2 text-sm text-hilevel-slate placeholder:text-hilevel-gray/60 focus:outline-none focus:ring-2 focus:ring-hilevel-red/30 focus:border-hilevel-red disabled:bg-hilevel-light disabled:text-hilevel-gray transition';

export const TextInput = forwardRef<HTMLInputElement, TextInputProps>(function TextInput(
  { type = 'text', className, ...rest },
  ref,
) {
  return <input ref={ref} type={type} className={cn(BASE, className)} {...rest} />;
});
